export default __webpack_public_path__ + "static/media/OurLaboratory.85adf3b3.PNG";